import { defineComponent as _defineComponent } from 'vue'
import { Studio } from '@/modules/Studios/types'
import { useImage } from '@/shared/composables/image'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudiosGridChip',
  props: {
    studio: null
  },
  setup(__props: any) {

const { getOrgImage } = useImage()


return { __sfc: true,getOrgImage }
}

})